import React from "react"
import Skeleton from "react-loading-skeleton"

function AchievementSkeleton() {
  return (
    <>
      <div>
        <Skeleton height={150} width={200} />
        <p className="uk-text-large">
          <Skeleton width={300} />
        </p>
      </div>
      <div>
        <Skeleton height={150} width={200} />
        <p className="uk-text-large">
          <Skeleton width={300} />
        </p>
      </div>
      <div>
        <Skeleton height={150} width={200} />
        <p className="uk-text-large">
          <Skeleton width={300} />
        </p>
      </div>
    </>
  )
}

export default AchievementSkeleton
